const STORAGE_KEY = 'mistral_rice_pending_win';
/** Подмешивание «won» только сразу после final_round: иначе `next_available` у бэка = «можно играть», не лаг GET. */
const PENDING_MERGE_TTL_MS = 30 * 60 * 1000;

function writeStorage(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch (e) {
    /* ignore */
  }
  try {
    sessionStorage.setItem(key, value);
  } catch (e) {
    /* ignore */
  }
}

function readStorage(key) {
  try {
    const v = sessionStorage.getItem(key);
    if (v) return v;
  } catch (e) {
    /* ignore */
  }
  try {
    const v = localStorage.getItem(key);
    if (v) return v;
  } catch (e) {
    /* ignore */
  }
  return null;
}

function removeStorage(key) {
  try {
    sessionStorage.removeItem(key);
  } catch (e) {
    /* ignore */
  }
  try {
    localStorage.removeItem(key);
  } catch (e) {
    /* ignore */
  }
}

function isFreshPendingWin(p) {
  if (!p || p.savedAt == null) return false;
  const t = Number(p.savedAt);
  if (!Number.isFinite(t)) return false;
  return Date.now() - t <= PENDING_MERGE_TTL_MS;
}

function normTitle(s) {
  return String(s || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');
}

function findWonRiceGameIndex(list, pending) {
  if (!pending || !Array.isArray(list) || list.length === 0) return -1;
  const slot = pending.slotIndex;
  const kazanId = pending.kazanId != null ? pending.kazanId : null;
  if (
    kazanId != null &&
    kazanId !== '' &&
    Number.isFinite(Number(slot)) &&
    slot >= 0 &&
    slot < list.length
  ) {
    const row = list[slot];
    if (row && (row.id === kazanId || String(row.id) === String(kazanId))) {
      return slot;
    }
  }
  const byTitle = normTitle(pending.matchTitle || pending.title);
  if (byTitle) {
    const i = list.findIndex((g) => g && normTitle(g.title) === byTitle);
    if (i >= 0) return i;
  }
  const apiId = pending.kazanId != null && pending.kazanId !== '' ? pending.kazanId : pending.apiId;
  if (apiId != null && apiId !== '' && Number(apiId) !== 0) {
    const i = list.findIndex((g) => g && (g.id === apiId || String(g.id) === String(apiId)));
    if (i >= 0) return i;
  }
  return -1;
}

export function setRiceGamePending(payload) {
  if (!payload) {
    clearRiceGamePending();
    return;
  }
  try {
    writeStorage(STORAGE_KEY, JSON.stringify(payload));
  } catch (e) {
    console.warn('riceGamePending: cannot write sessionStorage', e);
  }
}

export function clearRiceGamePending() {
  removeStorage(STORAGE_KEY);
}

export function readRiceGamePending() {
  try {
    const raw = readStorage(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

/**
 * После PATCH final_round GET won-rice иногда отстаёт — подмешиваем «won» из sessionStorage.
 * Если сервер уже вернул won — очищаем storage.
 */
export function mergePendingIntoWonRiceList(list) {
  const p = readRiceGamePending();
  if (!p || !Array.isArray(list) || list.length === 0) {
    return Array.isArray(list) ? [...list] : [];
  }
  if (!isFreshPendingWin(p)) {
    clearRiceGamePending();
    return [...list];
  }
  const next = [...list];
  const idx = findWonRiceGameIndex(next, p);
  if (idx < 0) {
    return next;
  }
  const row = next[idx] || {};
  const avail = row.available || row.status;
  const raw = (row && row.__raw && typeof row.__raw === 'object') ? row.__raw : {};
  const factsTitle = p.factsBlockTitle != null && String(p.factsBlockTitle).trim() ? String(p.factsBlockTitle).trim() : '';
  const factsDesc = p.factsBlockDescription != null && String(p.factsBlockDescription).trim() ? String(p.factsBlockDescription).trim() : '';
  const factsUrl = p.factsBlockUrl != null && String(p.factsBlockUrl).trim() ? String(p.factsBlockUrl).trim() : '';
  const gameFinished = p.game_finished != null && String(p.game_finished).trim() ? String(p.game_finished).trim() : '';
  const riceType = p.rice_type != null && String(p.rice_type).trim() ? String(p.rice_type).trim() : '';
  const hasFinal =
    Boolean(
      (row.factsBlockTitle && String(row.factsBlockTitle).trim())
      || (row.factsBlockDescription && String(row.factsBlockDescription).trim())
      || (row.game_finished && String(row.game_finished).trim())
      || (raw.facts_block_title && String(raw.facts_block_title).trim())
      || (raw.facts_block_description && String(raw.facts_block_description).trim())
      || (raw.game_finished && String(raw.game_finished).trim())
    );
  if (avail === 'won') {
    // Сервер уже отметил win, но won-rice может не содержать данных final_round — подмешиваем их из pending.
    if ((!hasFinal && (factsTitle || factsDesc || factsUrl || gameFinished)) || (riceType && !(row.rice_type || row.riceType || raw.rice_type))) {
      next[idx] = {
        ...row,
        __raw: {
          ...raw,
          ...(riceType ? { rice_type: riceType, riceType } : null),
          ...(factsTitle ? { facts_block_title: factsTitle, factsBlockTitle: factsTitle } : null),
          ...(factsDesc ? { facts_block_description: factsDesc, factsBlockDescription: factsDesc } : null),
          ...(factsUrl ? { facts_block_url: factsUrl, factsBlockUrl: factsUrl, url: factsUrl } : null),
          ...(gameFinished ? { game_finished: gameFinished } : null),
        },
        rice_type: row.rice_type || row.riceType || raw.rice_type || riceType,
        receipt: row.receipt || p.receipt,
        image: row.image || p.image,
        description: row.description != null ? row.description : p.description,
        factsBlockTitle: row.factsBlockTitle || factsTitle,
        factsBlockDescription: row.factsBlockDescription || factsDesc,
        factsBlockUrl: row.factsBlockUrl || factsUrl,
        game_finished: row.game_finished || gameFinished,
        available: 'won',
      };
    }
    clearRiceGamePending();
    return next;
  }
  /* Ответ PATCH final_round может содержать id не из won-rice — не подменяем «won», если слот уже в другом статусе. */
  if (avail !== 'next_available') {
    clearRiceGamePending();
    return next;
  }
  next[idx] = {
    ...row,
    __raw: {
      ...raw,
      ...(riceType ? { rice_type: riceType, riceType } : null),
      ...(factsTitle ? { facts_block_title: factsTitle, factsBlockTitle: factsTitle } : null),
      ...(factsDesc ? { facts_block_description: factsDesc, factsBlockDescription: factsDesc } : null),
      ...(factsUrl ? { facts_block_url: factsUrl, factsBlockUrl: factsUrl, url: factsUrl } : null),
      ...(gameFinished ? { game_finished: gameFinished } : null),
    },
    title: p.title || row.title,
    rice_type: row.rice_type || row.riceType || raw.rice_type || riceType,
    receipt: p.receipt != null && p.receipt !== '' ? p.receipt : row.receipt,
    image: p.image != null && p.image !== '' ? p.image : row.image,
    description: p.description != null ? p.description : row.description,
    factsBlockTitle: factsTitle || row.factsBlockTitle,
    factsBlockDescription: factsDesc || row.factsBlockDescription,
    factsBlockUrl: factsUrl || row.factsBlockUrl,
    game_finished: gameFinished || row.game_finished,
    available: 'won',
  };
  return next;
}
